import {styled} from '@mui/material';
import map from 'lodash/map';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import CompareSlider from '../../components/compare-slider.jsx';
import FrameLabel from '../../components/frame-label.jsx';
import FrameLogo from '../../components/frame-logo.jsx';
import {ASSETS_URL} from '../../config.js';
import {STORY_WIDTH} from '../../constants.js';

const Container = styled('div')(({theme}) => ({
  color: theme.palette.common.white,
  userSelect: 'none',
  position: 'relative',
}));

const StyledImage = styled('img')({
  display: 'block',
  maxWidth: '100%',
  pointerEvents: 'none',
});

const Comparate = styled('div')({
  height: '100%',
  backgroundSize: 'cover',
  backgroundPosition: 'right',
  position: 'absolute',
  right: 0,
  top: 0,
});

class Compare extends Component {
  static propTypes = {
    story: PropTypes.object.isRequired,
  };

  state = {
    position: 0.5,
    scale: 1,
  };

  componentDidMount() {
    window.addEventListener('resize', this.onResize);
    this.onResize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () =>
    this.setState({
      scale: Math.min(1, window.innerWidth / STORY_WIDTH),
    });

  onSliderChange = value => this.setState({position: value});

  render() {
    const baseUrl = `${ASSETS_URL}/${this.props.story.id}`;
    return (
      <Container>
        <StyledImage src={`${baseUrl}/frame-000.png`} />
        <Comparate
          style={{
            backgroundImage: `url(${baseUrl}/frame-001.png)`,
            left: `${this.state.position * 100}%`,
          }}
        />
        <div>
          {this.props.story.frames.map(frame => {
            const date = new Date(frame.date);
            return (
              <FrameLabel
                key={map(frame.images, 'id').toString()}
                scale={this.state.scale}
              >
                {date.toLocaleDateString()}
              </FrameLabel>
            );
          })}
        </div>
        <FrameLogo scale={this.state.scale} />
        <CompareSlider
          position={this.state.position}
          onChange={this.onSliderChange}
        />
      </Container>
    );
  }
}

export default Compare;
